const learningCenterIdentifer = learningCenter => {
  const activeSlugs =
    learningCenter.slugs &&
    learningCenter.slugs.length > 0 &&
    learningCenter.slugs.filter(slug => slug.active);

  if (activeSlugs && activeSlugs.length > 0) {
    return activeSlugs[0].slug_text;
  }

  return learningCenter.id;
};

export default learningCenterIdentifer;
